import useFetchSingleChallenge from '@pages/challengeGroups/challenge/_hooks/useFetchSingleChallenge';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import Description from 'lib/src/components/typography/Description';
import Title from 'lib/src/components/typography/Title';
import { isEmpty } from 'lib/src/utils/generic';
import { useParams } from 'react-router-dom';
import { createAssessmentBreadcrumbs } from '../../../../../constants/breadcrumbItems';
import useFetchSubmission from '../../hooks/useFetchSubmission';

import CreateAssessmentForm from './CreateAssessmentForm';

interface Params {
    id: string;
}

const CreateAssessment = () => {
    const { id } = useParams<Params>();

    const {
        submission,
        isFetching: submissionIsFetching,
        fetchError: submissionFetchError,
    } = useFetchSubmission(parseInt(id));

    const {
        challenge: assessmentChallenge,
        isFetching: assessmentChallengeIsFetching,
        fetchError: assessmentChallengeFetchError,
    } = useFetchSingleChallenge(submission.challengeID);

    createAssessmentBreadcrumbs[2].name =
        assessmentChallenge == null ? 'Loading' : assessmentChallenge.name;
    createAssessmentBreadcrumbs[2].link = `/assessments/submissions/${
        assessmentChallenge?.id || ''
    }`;

    return (
        <>
            <DataCheck
                dataExists={!isEmpty(submission)}
                isFetching={submissionIsFetching || assessmentChallengeIsFetching}
                error={submissionFetchError || assessmentChallengeFetchError}
            >
                <Breadcrumb items={createAssessmentBreadcrumbs} />
                <Title>Assessing Submission</Title>
                <Description>Assessing submission by {submission.companyName}</Description>

                <CreateAssessmentForm submission={submission} />
            </DataCheck>
        </>
    );
};

export default CreateAssessment;
